// extracted by mini-css-extract-plugin
export default {"heading":"VizyonumuzContainer_heading__WBYeJ","banner":"VizyonumuzContainer_banner__TTQ++"};